import { render, staticRenderFns } from "./productMain.vue?vue&type=template&id=60344972&scoped=true&"
import script from "./productMain.vue?vue&type=script&lang=js&"
export * from "./productMain.vue?vue&type=script&lang=js&"
import style0 from "./productMain.vue?vue&type=style&index=0&id=60344972&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60344972",
  null
  
)

export default component.exports